interface PeekIconStaticProps {
  className?: string;
}

export function PeekIconStatic({ className = "" }: PeekIconStaticProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ shapeRendering: "geometricPrecision" }}
    >
      {/* Background rounded square */}
      <path
        d="M78 0H22C9.84974 0 0 9.84974 0 22V78C0 90.1503 9.84974 100 22 100H78C90.1503 100 100 90.1503 100 78V22C100 9.84974 90.1503 0 78 0Z"
        fill="#FF6B7B"
      />

      {/* White peek shape */}
      <path
        d="M100 43.75V100H43.75C43.75 100 43.75 68.75 62.5 56.25C75 46.875 100 43.75 100 43.75Z"
        fill="white"
      />

      {/* White triangle */}
      <path
        d="M56.25 81.25L43.75 100H68.75L56.25 81.25Z"
        fill="white"
      />

      {/* Eye circle */}
      <path
        d="M75 81.25C78.4518 81.25 81.25 78.4518 81.25 75C81.25 71.5482 78.4518 68.75 75 68.75C71.5482 68.75 68.75 71.5482 68.75 75C68.75 78.4518 71.5482 81.25 75 81.25Z"
        fill="#FF6B7B"
      />
    </svg>
  );
}
